import { render, staticRenderFns } from "./xl.vue?vue&type=template&id=085b50a8&scoped=true&"
import script from "./xl.vue?vue&type=script&lang=js&"
export * from "./xl.vue?vue&type=script&lang=js&"
import style0 from "./xl.vue?vue&type=style&index=0&id=085b50a8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "085b50a8",
  null
  
)

export default component.exports